<template>
    <a-transfer
        :dataSource="dataSource"
        showSearch
        :filterOption="filterOption"
        :targetKeys="targetKeys"
        @change="handleChange"
        @search="handleSearch"
        :render="item => `${item.title}: ${item.description}`"
    />
</template>

<script>

const mockData = [
    {
        title: 'Admin',
        description: 'admin jogok',
        key: '1',
        chosen: false
    },
    {
        title: 'Olvasó',
        description: 'olvasó jogok',
        key: '2',
        chosen: false
    },
    {
        title: 'Szerkesztő',
        description: 'szerkesztő jogok',
        key: '3',
        chosen: false
    }
]

export default {
    
    // props: {
    //     dataSource: Array
    // },

    data() {
        return {
            dataSource: mockData,
            targetKeys: []
        }
    },

    methods: {
        filterOption(inputVal, option) {
            console.log(inputVal);
            console.log(option);
            return option.description.indexOf(inputVal) > -1;
        },
        handleChange(targetKeys, direction, moveKeys) {
            this.targetKeys = targetKeys
        },
        handleSearch(dir, value) {
        }
    }

    
}
</script>

<style lang="scss" scoped>

</style>
